import type { FaireProductEntity } from "../../entity_types/product";

export const p_aqmjevz36r: FaireProductEntity = {
  token: "p_aqmjevz36r",
  type: "product",
  name: "Natural Stone Stainless Steel Adjustable Vintage Ring-FGS/CS",
  brandToken: "b_nex9pcmkzj",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/6f31a49b5c2c19ef1206d07610c11bf7006745985008770c90ee09a08460c964.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/4d7c436e1acf2a3d41697728800ac360f807a282e951b2e7b26cafe7cbb7e8c0.jpeg",
    "https://cdn.faire.com/fastly/52ef7dab51be109bd96a57d1621a1ffaf561026d3c73248cb8b593b77a6a5738.jpeg",
    "https://cdn.faire.com/fastly/369bd258a6a1a2f1f9b2c03e78b0e8e8da318ded309d820fe4ac8e3c46abc480.jpeg",
    "https://cdn.faire.com/fastly/8a88c72cbb87cb3b52927910e8cf146c3ce383e5b8274595fc431d8463ea9b5b.jpeg",
    "https://cdn.faire.com/fastly/16a90ccc3a0f52685535ee5763a0f1df964d2865693375c1c5780655d7a97e38.jpeg",
    "https://cdn.faire.com/fastly/c037dcda750c34e0c25babe5e9a864eb3b3a3a3571e24b2d32a4ab511086ae74.jpeg",
    "https://cdn.faire.com/fastly/f862050b21a51d1b88df604966d79347d1252022940d6bf50017dbca128c40cb.jpeg",
  ],
  priceDollars: 11.52,
  description:
    "Material: stainless steel, natural stone, glass, enamel  \n\nsize: opening adjustable \n\nweight: about 6-8g/pcs\n \n\n★Made of high quality stainless steel, Nickel-free / Lead-free  , Harmless to Human Body.\n\n★Perfect jewelry gifts\n\n\n\n\n\n\n                  \n",
  tags: [],
  msrpDollars: 23.03,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:10.273Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
